import { Button, ComponentBase, Div, RefBool, Span } from "@tblabs/truffle";
import { Svg } from "../../../Pages/Components/Utils/Svg";
import { Icons } from "../Icons";


export class AccordionButtonV1 extends ComponentBase<HTMLHeadingElement>
{
    constructor(title: string)
    {
        super(`h3`);
        this.Class("accordion__header");

        this.Html(`<button type="button" aria-controls="radix-:r19:" aria-expanded="true" data-state="open" data-orientation="vertical" id="radix-:r17:" class="accordion__trigger product-accordion__trigger" data-radix-collection-item=""><div class="product-accordion__row">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-percent-square product-accordion__icon text-rose-400"><rect width="18" height="18" x="3" y="3" rx="2"></rect><path d="m15 9-6 6"></path><path d="M9 9h.01"></path><path d="M15 15h.01"></path></svg><span class="product-accordion__title">${title}</span></div><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-down accordion__icon"><path d="m6 9 6 6 6-6"></path></svg>
        </button>`);
    }
}

export class AccordionButton extends Div
{
    constructor(title: string)
    {
        super(`h3`);
        this.Class("accordion__header");

        const isOpen = new RefBool(false);

        this.OnClick(() => isOpen.Toggle());

        this.Append(
            new Button("").Class("accordion__trigger product-accordion__trigger")
                .Append(
                    new Div().Class("product-accordion__row").Append(
                        new Svg(Icons.PercentSquare),
                        new Span(title).Class("product-accordion__title"),
                    ),
                    new Svg(Icons.ChevronDown).Visible(isOpen),
                    new Svg(Icons.ChevronUp).VisibleWhen(isOpen, v => !v),
                )
        )
    }
}
